import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LOOKBOOK_ENTITIES_STATE_KEY } from './constants';
import { State } from './lookbook-entities.adapter';
import { LookBookEntity } from './model';

export const selectLookBookEntitiesState = createFeatureSelector<State>(
  LOOKBOOK_ENTITIES_STATE_KEY,
);

export const selectLookBookEntity = (id: string) =>
  createSelector(
    selectLookBookEntitiesState,
    (state: State) => state.entities[id],
  );

export const selectLookbookEntityForTracking = createSelector(
  selectLookBookEntitiesState,
  (state) => {
    const allLookBooks = Object.values(state.entities) as LookBookEntity[];
    const lookBookGTMTable: {
      [key: string]: { lookBookName: string; listName: string };
    } = {};

    allLookBooks.forEach((lookBook) => {
      lookBook.lookBook?.items?.forEach((list) => {
        lookBookGTMTable[`${lookBook.lookBookId}:${list.productListId}`] = {
          lookBookName: lookBook.lookBook?.title as string,
          listName: list.productList.name,
        };
      });
    });

    return lookBookGTMTable;
  },
);
